import React from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Question, Questionnaire } from "./models";

const QuestionLabelView = ({ question, questionnaire }: { question: Question, questionnaire: Questionnaire }) => {
  const { t } = useTranslation(questionnaire.cohort);

  return (
    <div>
      <Typography variant="h6" component='div'>
        {t(question.question)}
      </Typography>
    </div>
  );
}

export default QuestionLabelView;
